import { Box, ImageList, ImageListItem, Typography } from "@mui/material";
import images from '../../../../../data/images.json';

export default function HomePage() {
    const imagesArray = images.home;

    return (
        <Box sx={{ position: 'relative', height: 'calc(100vh - 250px)', overflow: 'hidden' }}>
            {/* Background masonry image list */}
            <Box
                sx={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    overflowY: 'hidden',
                    zIndex: 0,
                }}
            >
                <ImageList variant="masonry" cols={5} gap={8}>
                    {imagesArray.map((image, i) => (
                        <ImageListItem key={`Image_${i}`}>
                            <img
                                srcSet={`${image.src}?w=248&fit=crop&auto=format&dpr=2 2x`}
                                src={`${image.src}?w=248&fit=crop&auto=format`}
                                alt={image.alt}
                                loading="lazy"
                            />
                        </ImageListItem>
                    ))}
                </ImageList>
            </Box>

            {/* Foreground content */}
            <Box
                sx={{
                    position: 'relative',
                    zIndex: 1,
                    backgroundColor: 'rgba(255, 255, 255, 0.8)',
                    padding: 4,
                    maxWidth: '600px',
                    margin: '0 auto',
                    mt: 8,
                    borderRadius: 2,
                }}
            >
                <Typography variant="h4" gutterBottom>
                    Μεζεδοπωλείο
                </Typography>
                <Typography sx={{display:"flex",justifyContent:'center'}}>
                    Κάθε Μέρα 12:30 μ.μ. - 12:15 π.μ.
                </Typography>
            </Box>
        </Box>
    );
}